import { useQuery } from '@tanstack/react-query';

export const usePreloadAssets = () => {
  const assetsToPreload = [
    // Sounds
    '/sound/win.mp3',
    '/sound/loss.mp3',
    '/sound/cashout.mp3',
    '/sound/click.mp3',
    // Spine rat
    '/spine/rat.json',
    '/spine/rat_idle2_2.png',
    '/spine/rat_idle2.atlas',
    '/spine/rat_idle2.png',
    // Spine coins
    '/spine/coins/coins-all.atlas',
    '/spine/coins/coins-all.webp',
    '/spine/coins/skeleton.json',
    // Game assets
    '/game/logo.webp',
    '/game/frame.webp',
    '/game/frame_mobile.webp',
    '/game/background.webp',
    '/game/cashout_frame.webp',
    // Icons
    '/icons/cheese.webp',
    '/icons/coin.webp',
  ];

  const preloadAll = async () => {
    await Promise.all(assetsToPreload.map((asset) => fetch(asset)));

    return true;
  };

  return useQuery({
    queryKey: ['preloadAssets'],
    queryFn: preloadAll,
    staleTime: Number.POSITIVE_INFINITY, // These assets don't change, so we can cache them forever
  });
};
